// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-panel[data-v-50c697e9] {\n  position:absolute;\n  top:0;\n  left:0;\n  width:100%;\n  height:100%;\n}\n.center p[data-v-50c697e9] {\n  font-weight: bold;\n  margin: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n", ""]);
// Exports
module.exports = exports;
